import SchoolIcon from "@mui/icons-material/School";
import { GraduationServicePath, STATE_EXAMS } from "utils/constants";
import permissions from "app/permissions";
import ListInternshipStateExams from "./LIst";
import ShowInternshipStateExams from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <SchoolIcon />,
  name: GraduationServicePath + STATE_EXAMS,
  title: "Държавни изпити",
  list: <ListInternshipStateExams />,
  show: <ShowInternshipStateExams />,
  permission: permissions.canPreviewStateExams,
};
